import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countReceivedTimes'
})
export class CountReceivedTimesPipe implements PipeTransform {
  transform(value: any): any {
    if (!!value === false) {
      return;
    }
    const num = Object.keys(JSON.parse(value)).length;
    if (num === 0) {
      return null;
    } else {
      return num;
    }
  }
}
